var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"label":_vm.$t(`filters.labels.${_vm.name}`),"items":_vm.items,"clearable":""},on:{"change":function($event){return _vm.$emit('applyFilter', { name: _vm.name, value: _vm.model })}},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})
}
var staticRenderFns = []

export { render, staticRenderFns }